/* @flow */

import ProgressPromise from './progress_promise'

export const support = {
  blob:
    'FileReader' in window &&
    'Blob' in window &&
    (() => {
      try {
        new Blob()
        return true
      } catch (e) {
        return false
      }
    })(),
  formData: 'FormData' in window
}

export const decode = (body: string) => {
  const form = new FormData()
  body
    .trim()
    .split('&')
    .forEach((bytes) => {
      if (bytes) {
        const split = bytes.split('=')
        const name = split.shift().replace(/\+/g, ' ')
        const value = split.join('=').replace(/\+/g, ' ')
        form.append(decodeURIComponent(name), decodeURIComponent(value))
      }
    })
  return form
}

export const consumed = (body: { bodyUsed: boolean }) => {
  if (body.bodyUsed) {
    return ProgressPromise.reject(new TypeError('Already read'))
  }
  body.bodyUsed = true
}

export const fileReaderReady = (reader: any) => {
  return new ProgressPromise((resolve, reject) => {
    reader.onload = () => {
      resolve(reader.result)
    }
    reader.onerror = () => {
      reject(reader.error)
    }
  })
}

export const readBlobAsArrayBuffer = (blob: Blob) => {
  const reader = new FileReader()
  reader.readAsArrayBuffer(blob)
  return fileReaderReady(reader)
}

export const readBlobAsText = (blob: Blob) => {
  const reader = new FileReader()
  reader.readAsText(blob)
  return fileReaderReady(reader)
}

export const noXhrPatch = !!window.ActiveXObject && !(window.XMLHttpRequest && new XMLHttpRequest().dispatchEvent)

export const responseURL = (xhr: XMLHttpRequest) => {
  if ('responseURL' in xhr) {
    return xhr.responseURL
  }

  // Avoid security warnings on getResponseHeader when not allowed by CORS
  if (/^X-Request-URL:/m.test(xhr.getAllResponseHeaders())) {
    return xhr.getResponseHeader('X-Request-URL')
  }
}
